import React from "react";
import { Link } from "react-router-dom";

const NoPermission = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4">
        <h1 className="display-4 text-danger">403</h1>
        <h3 className="mb-3">No Permission</h3>
        <p className="text-muted mb-4">
          You do not have permission to access this page.
        </p>
        <Link to="/dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NoPermission;
